import { CalendarWeek, LockFill, Circle, Check, ClockHistory } from 'react-bootstrap-icons';

import { Timeline } from 'antd';

import { useBreakpoints } from '@/hooks/useBreakpoints';
import { blockedStatus, enStatus, IModule } from '@/interfaces/course';
import styled, { css, StyledProp } from '@/styled';

import LessonItem from './Item';

const blockedIconMapper: Record<string, React.ReactElement> = {
  [enStatus.EXPIRED]: <ClockHistory size={24} />,
  [enStatus.NOT_RELEASED]: <CalendarWeek size={24} />,
  [enStatus.NOT_PURCHASED]: <LockFill size={24} />
};

const getTimelineIcon = (lessonStatus: enStatus, watched: boolean) => {
  if (blockedStatus.includes(lessonStatus)) return blockedIconMapper[lessonStatus];

  if (watched)
    return (
      <div className='modules-timeline-watched'>
        <Check size={18} />
      </div>
    );

  return <Circle size={24} className='modules-timeline-circle' />;
};

const Lessons = (props: StyledProp & { module: IModule }) => {
  const breakpoints = useBreakpoints();

  if (breakpoints.down('lg')) {
    return (
      <div className={props.className}>
        <div className='mobileList'>
          {props.module.lessons.map(lesson => (
            <LessonItem moduleId={`${props.module?.id}`} key={lesson.id} lesson={lesson} />
          ))}
        </div>
      </div>
    );
  }

  const defaultDot = {
    dot: <div />,
    children: <div style={{ height: 24 }} />
  };

  return (
    <div className={props.className}>
      <Timeline
        items={[
          defaultDot,
          ...props.module.lessons.map(lesson => ({
            color: 'white',
            dot: getTimelineIcon(lesson.status, lesson.watched),
            children: <LessonItem lesson={lesson} />
          }))
        ]}
      />
    </div>
  );
};

export default styled(Lessons)(({ theme }) => {
  return css`
    .mobileList {
      display: flex;
      flex-direction: column;
      gap: ${theme.space.pxToRem(24)};
    }

    .ant-timeline-item-head-custom {
      transform: translate(-50%, 100%);
    }

    .ant-timeline-item-last {
      .ant-timeline-item-tail {
        display: block;
        border-inline-start: 1px solid ${theme.variables.borderColor};
        height: calc(100% - 90px);
      }
    }

    .ant-timeline-item-head {
      background: transparent;

      svg {
        background: ${theme.variables.bgComponentsContainer};
        color: ${theme.variables.courseModuleCheck.background};
      }
    }

    .ant-timeline-item-tail {
      border-inline-start: 1px solid ${theme.variables.borderColor};
      height: 100%;
    }

    .ant-timeline-item-content {
      margin-inline-start: 48px;
    }

    .ant-timeline {
      transform: translateY(-38px);
    }

    .modules-timeline-circle {
      color: ${theme.palette.gray[8]};
      background-color: ${theme.palette.gray[10]};
    }

    .modules-timeline-watched {
      height: 24px;
      width: 24px;
      border-radius: 100%;
      display: flex;
      background: ${theme.variables.courseModuleCheck.background};

      svg {
        transition: ${theme.motionDurationMid};
        background-color: transparent;
        margin: auto;
        color: ${theme.variables.courseModuleCheck.color};
      }
    }
  `;
});
